export default __webpack_public_path__ + "static/media/project2.636bf715.jpg";